import useGetInadimplencia from "core/features/acordo/hooks/useGetInadimplencia";
import { useState } from "react";
import SelectBaseAntd, { SelectBaseAntdProps } from "../SelectBaseAntd";

export interface SelectMotivoInadimplenciaProps<T = any>
  extends SelectBaseAntdProps<T> {
  value: any;
  onChange: (v: any) => void;
}

export default function SelectMotivoInadimplencia({
  value,
  onChange,
  ...rest
}: SelectMotivoInadimplenciaProps) {
  const [search, setSearch] = useState<string>();

  const { isLoading, data } = useGetInadimplencia();

  return (
    <SelectBaseAntd
      loading={isLoading}
      size="large"
      placeholder="Motivo inadimplência"
      style={{ width: "100%" }}
      value={value}
      allowClear={false}
      showSearch
      searchValue={search}
      onSearch={setSearch}
      onChange={onChange}
      optionFilterProp="label"
      options={data?.map((item: any) => ({
        value: item.id,
        label: item.nome,
      }))}
      {...rest}
    />
  );
}
